var map = {
	"./agree.svg": 8962,
	"./arrow.svg": 8813,
	"./arrow_green.svg": 3932,
	"./arrow_white.svg": 8057,
	"./check_mark.svg": 4366,
	"./checked.svg": 4443,
	"./coin_icon.svg": 2201,
	"./cup_icon.svg": 9661,
	"./error_result.svg": 6798,
	"./green_background.svg": 2722,
	"./iwalk_logo.svg": 9878,
	"./iwalk_new_logo.svg": 2692,
	"./like.svg": 2411,
	"./logo.svg": 2835,
	"./map_image.svg": 1115,
	"./pause.svg": 1118,
	"./pink_background.svg": 2751,
	"./play.svg": 8215,
	"./success_result.svg": 174,
	"./wave.svg": 3599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;